import routeMap from "../routeMap";
import GetIcon from "../IconsComponent";
import { useMemo } from "react";

export const findRouteKey = (path) => {
    return (
        Object.entries(routeMap)
            .filter(([_, value]) => path.startsWith(value))
            .sort((a, b) => b[1].length - a[1].length)?.[0]?.[0] || null
    );
};

export const BuildNavigation = (menu, rujul_menu) => {
    const formattedSubmenus = {};

    rujul_menu.forEach(item => {
        const title = item.menu_details?.title;
        if (title && title !== "MASTER" && item.submenus?.allmenu) {
            formattedSubmenus[title] = item.submenus.allmenu;
        }
    });

    const rujulFormatted = {
        menu_details: {
            icon: "fa-solid fa-user-tie",
            title: "ADMIN",
        },
        submenus: formattedSubmenus,
    };

    const route_arr =
        formattedSubmenus && Object.keys(formattedSubmenus).length > 0
            ? [...menu, rujulFormatted]
            : [...menu];

    const { new_routes, alloweObjectIds } = useMemo(() => {
        let new_routes = [];
        let alloweObjectIds = [];
        if (Array.isArray(route_arr)) {
            for (let row of route_arr) {
                if (
                    [
                        "RMG",
                        "PROJECT MANAGEMENT",
                        "Human Resource",
                        "TIME SHEET",
                        "SUPPORT DESK",
                        "PAYROLL",
                        "ORGANIZATION",
                        "Payroll Management",
                        "ADMIN",
                    ].includes(row.menu_details.title)
                ) {
                    let temp = {
                        name: row.menu_details.title,
                        // path: "/",
                        exact: true,
                        // icon:  <i classGet(Name={ row.menu_details.icon}/>,
                        icon: GetIcon(row.menu_details.icon),
                        subRoutes: [],
                    };

                    let subMenuArr = [];
                    if (row.submenus && Object.keys(row.submenus).length > 0) {
                        Object.keys(row.submenus).forEach((subkey) => {
                            if (
                                ![
                                    "allmenu",
                                    // "Report",
                                    // "Training",
                                    // "Resource",
                                    // "Task",
                                    // "Attendance",
                                    // "Performance Review",
                                    "Imports",
                                    "Communication", //rujul
                                    "Balance Sheet", //rujul
                                    "Trial Balance", //rujul
                                    // "Leave Management", //rujul
                                    "Profit & Loss", //rujul
                                ].includes(subkey)
                            ) {
                                let subSubRoute = [];
                                for (let childMenu of row.submenus[subkey]) {
                                    if (
                                        ![
                                            // "Incentives Master",

                                            // "Award Master",

                                            "TnE Invoice list (Consulting and Content)",
                                            // "TnE Invoice List (Training)",
                                            "Update Invoice List (Training)",
                                            // "Invoice List (Training)",
                                            // "Invoice Report (Training)",
                                            "Internal Project",
                                            "KPI Report (Training)",
                                            // "All Invoice Report",
                                            // "All Reports",
                                            // "TnE Invoice Report (Consulting and Content)",
                                            // "TnE Invoice Report (Training)",
                                            // "My Projects",
                                            // "Project Status Report",
                                            "Cancel Leave Request",
                                            "Incentive List (Training)",
                                            "Update Invoice List (Consulting & Content)",
                                            "Incentive List Fixed Bid",
                                            "Team Incentives",
                                            "Payroll Statements",
                                            "Attendance Approvals",
                                            "Attendance Statements",
                                            "Accrued Leave Summary",
                                            "Available Leave Summary",
                                            "Support Ticket Resolution",
                                            "Users Permission",
                                            "Resource Requisition",
                                            "Domains",
                                            "Resource Requisition Approval",
                                            "Employee Report",
                                            "Announcement",
                                            "Skills",
                                            "Employee",
                                            "Employee Qualification",
                                            "Attendance Register",
                                            "Daily Attendance",
                                            // "Income Tax Slab",
                                            "Employee Payrolls",
                                            "Employee Payrolls List",
                                            // "Payroll Statement",
                                            "Update Incentive List(Consulting & Content)",
                                            "Incentive List",
                                            "Employee Leave",
                                            "Employee Shifts",
                                            "Employee Leave List",
                                            "Employee Shifts List",
                                            "Payroll Journal Voucher",
                                            "Payroll Journal Voucher List",
                                            "Employee Payment",
                                            "Company Policies",
                                            "Widget",
                                            "Log Statement",
                                            "Active Login User",
                                            "Active Login User",
                                            "Transaction Log Statement",
                                            // "Users Permission",
                                            "Dashboard Designer",
                                            // "Expense Settlement Statements",
                                            "Expense Settlement",
                                            "Attendance Register",
                                            // "Attendance Statement",
                                            // "Attendance Approval",
                                            "Scales",
                                            // "Attendance Book Statement",
                                            "Attendance In Out Summary",
                                            "Attendance Log Statement",
                                            "Attendance Book Summary",
                                        ].includes(childMenu.DiplayName)
                                    ) {
                                         alloweObjectIds.push(childMenu.ObjectType);
                                         subSubRoute.push({
                                             path: routeMap[childMenu.ObjectType],
                                             name: childMenu.DiplayName,
                                             icon: GetIcon(childMenu.Icon?.trim() || childMenu.Icon),
                                         });
                                    }
                                }
                                subMenuArr.push({
                                    // path: "/",
                                    name: subkey === "Recruitment Process" ? "TA" : subkey,
                                    icon: GetIcon(row.submenus[subkey][0].subGroupMenuIcon),
                                    subRoutes: subSubRoute,
                                });
                            }
                        });

                        temp.subRoutes = subMenuArr;
                    }

                    if (row.submenus?.allmenu) {
                        for (let first_row of row?.submenus?.allmenu) {
                            if (
                                ![
                                    "Attendance Register",
                                    // "Attendance Book Statement",
                                    "Attendance In Out Summary",
                                    "Attendance Log Statement",
                                    "Attendance Book Summary",
                                    "Holiday",
                                    // "Shift",
                                    "Forum",
                                    "Announcement",
                                    "TnE Invoice list (Consulting and Content)",
                                    "TnE Invoice List (Training)",
                                    "Update Invoice List (Training)",
                                    "Invoice List (Training)",
                                    "Employee Qualification",
                                    "Attendance Status",
                                    "HR Calendars",
                                    "Company Policies",
                                    // "Designation",
                                    "Skills",
                                    "Employee Report",
                                    "Employee List",
                                    // "Attendance Statement",
                                    // "Attendance Approval",
                                    "Daily Attendance",
                                    "Mark Attendance",
                                    "HR Incentive List",
                                    ,
                                ].includes(first_row.DiplayName)
                            ) {
                                alloweObjectIds.push(first_row.ObjectType);
                                subMenuArr.push({
                                    path: routeMap[first_row.ObjectType],
                                    name: first_row.DiplayName,
                                    icon: GetIcon(first_row.Icon?.trim() || first_row.Icon),
                                });
                            }
                        }
                    }

                    temp.subRoutes = subMenuArr;
                    new_routes.push(temp);
                }
            }
        }

        return { new_routes, alloweObjectIds };
    }, [route_arr]);
    return { new_routes, alloweObjectIds };
};

export const actionsArray = [
    "/dashboard",
    "/",
    "/change-password",
    "/candidate-details",
    "/special-leave",
    "/candidate-details-verify",
    "/view-job-description",
    "/change-password",
    "/RMG/employees",
    "/RMG/sub-contractors",
    "/RMG/employees/view/",
    "/addfeedback",
    "/view-feedbacks",
    "/feedback-link-expire",
    "/feedback-submitted",
    "/offer-accepted",
    "/dashboard",
    "/",
    "/candidate-details",
    "/special-leave",
    "/attendanceCalender",
    "/50881180195049806954114046419509",
    "/508811801950498069541140464195090",
    "/leave-approves",
    '/forthcoming',
    '/whatsnew',
    '/achievers',
    '/achievers/leaderboard',
    // '/employee-profile',
    '/apply/special-leave',
    '/approve/special-leave',
    '/candidate-details-ta-verify'
    // '/annual-bonus-report',
    // '/annual-appraisal-report'
];

export const customMappings = {
    'whatsnew': "What's New",
    'rmg': "RMG",
    'hr': "HR",
    'faq': "FAQ",
    'forthcoming': "Forthcoming",
    'dashboard': "Dashboard",
    '50881180195049806954114046419509': ['Human Resource', 'Birthday Details'],
    'birthday-details': "Birthday Details",
    'candidate-details': "Candidate Details"
  };

export const checkAction = (path) =>
    actionsArray.some(route =>
        path === route ||
        path.startsWith(route + "/") ||
        route.startsWith(path + "/")
    );
